var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-all-content"},[_c('zhuanti-top-block'),_c('zhuanti-map-block'),_c('chzx-block'),_c('jwzh-block'),_c('zzqs-block'),_c('hyfx-block'),_c('org-ana-block'),_c('czzc-block'),_c('qych-block')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }